import type {Household} from "../types";

export function formatHouseholdPin(pin: Household["pin"]): string | null {
  if (pin == null) return null;
  const text = String(pin).trim();
  return text.length > 0 ? text : null;
}

export function formatHouseholdComboboxDescription(household: Household): string {
  const address = `${household.number} ${household.street}, ${household.city}, ${household.state} ${household.zipcode}`
    .replace(/\s+,/g, ",")
    .trim();

  const pin = formatHouseholdPin(household.pin);
  if (pin && address) return `PIN ${pin} · ${address}`;
  if (pin) return `PIN ${pin}`;
  return address;
}
